import React, { useEffect } from 'react';
import Header from 'components/Common/Header/Header';
import Footer from 'components/Common/Footer/Footer';
import { Outlet, useLocation } from 'react-router-dom';

const MainLayout: React.FC = () => {
	const location = useLocation();
	useEffect(() => {
		window.scrollTo({
			top: 0,
			behavior: 'instant',
		});
	}, [location?.pathname]);

	return (
		<>
			<Header />
			<Outlet />
			<Footer />
		</>
	);
};

export default MainLayout;
